export const PORTFOLIO_TYPE_TAGS_KEY = 'PORTFOLIO_TYPE_TAGS';

export const TAX_STATUS_TAGS_KEY = 'TAX_STATUS_TAGS';

export const PORTFOLIO_STRUCTURE_TAGS_KEY = 'PORTFOLIO_STRUCTURE_TAGS';

export const MONITORING_STATUS_KEY = 'MONITORING_STATUS';

export const TAX_STATUS_TITLE_KEY = 'TAX_STATUS';

export const VEHICLE_TYPE_TAGS_KEY = 'VEHICLE_TYPE_TAGS';

export const OBJECTIVE_TAGS_KEY = 'OBJECTIVE_TAGS';

export const RULE_STATUS_KEY = 'RULE_STATUS';

export const PORTFOLIO_TYPE_TAG_TITLE = 'Portfolio Type';

export const PORTFOLIO_STRUCTURE_TAG_TITLE = 'Portfolio Structure';

export const MONITORING_STATUS_TITLE = 'Monitoring Status';

export const TAX_STATUS_TITLE = 'Tax Status';

export const RULE_STATUS_TITLE = 'Rule Status';
